import { render, staticRenderFns } from "./MemberDetailUserLayout.vue?vue&type=template&id=02d4f38a&scoped=true"
import script from "./MemberDetailUserLayout.vue?vue&type=script&lang=js"
export * from "./MemberDetailUserLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d4f38a",
  null
  
)

export default component.exports